define('casino/bundles',['jquery', 'casino/casino', 'casino/casino-data', 'all/Object'], function($, casino, casinoData) {
	'use strict';

	var bundles = {};

	function activate($this) {
		$('#bundles').find('.bundle').first().addClass('active');
		$this.addClass('active');
	}

	function deactivate() {
		var $bundles = $('#bundles');
		$bundles.find('.bundle').removeClass('active');
		$bundles.find('.slideshow > .grid > section').removeClass('active');
	}

	function showGamesInBundle($this, $gamesHolder, arrowPush) {
		var bundleId = $this.data('bundle');
		activate($this);
		// Do not replace these two find calls with a variable since they actually return two different objects
		$gamesHolder.find('.grid').populate(casinoData.bundles[bundleId]);
		$gamesHolder.find('.grid').prepend('<div class="arrow push push-' + arrowPush + '"/>');
		$gamesHolder.slideDown(800);
	}

	bundles.init = function () {
		var $bundles = $('#bundles');

		if(Object.keys(casinoData.bundles).length === 0) {
			$bundles.hide();
			return;
		}

		$bundles.find('.holder').hide();
		$bundles.find('.slideshow > .grid > section').each(function () {
			var gamesInBundle = casinoData.bundles[$(this).data('bundle')];
			var matchingGames = casino.getMatchingGames(gamesInBundle);
			var gameCount = matchingGames.length;

			$(this).find('.badge-count').text(gameCount);
			$(this).find('a').click(function (event) {
				event.preventDefault();
			});
			$(this).click(function () {
					var $this = $(this);
					var arrowPush = ($this.index() + 1) * 2;
					var $gamesHolder = $this.parent().find('.holder').first();
					var visible = $gamesHolder.is(':visible');
					var shouldOpen = !visible || $gamesHolder.data('bundle') !== $this.data('bundle');
					var show = function () {
						deactivate();
						if (shouldOpen) {
							$('html,body').animate({scrollTop: $bundles.offset().top});
							$gamesHolder.data('bundle', $this.data('bundle'));
							showGamesInBundle($this, $gamesHolder, arrowPush);
						}
					};
					if (visible) {
						$gamesHolder.slideUp(400, show);
					} else {
						show();
					}
				});
		});
		var $pagination = $bundles.find('.ui-pagination');
		if ($pagination && $pagination.length > 0) {
			$bundles.scroller({direction: 'left', auto: false});
			$pagination.find('a').click(function () {
				if (!$(this).parent().is('li.active')) {
					$bundles.find('.holder:visible').slideUp(800, deactivate);
				}
			});
		}
		deactivate();
	};

	return bundles;
});

